require('./bootstrap')
require('bootstrap-sass');
require('vue-bootstrap.js');

import ResultItem from './components/ResultItem.vue'
import ResultList from './components/ResultList.vue'
import SearchTagList from './components/SearchTagList.vue'
import SearchTag from './components/SearchTag.vue'
import Modal from './components/Modal.vue'

Vue.component('result-item', ResultItem);
Vue.component('result-list', ResultList);
Vue.component('search-tag-list', SearchTagList);
Vue.component('search-tag', SearchTag);
Vue.component('modal', Modal);


var musicSearcher = new Vue({
	el: '#search-box',

	data: {
		searchType: 'all',
		searchString: '',
		results: [],
		firstLoad: true,

		last: 0,
		limit: 25,
		total: 0,

		tags: [],
		tagList: [],
		searching: false,
		showModal: false,
		musicDetail: {},
	},

	computed: {

		rangeTop: function () {
			return (this.last + this.limit >= this.total) ? this.total : this.last + this.limit;
		},

		showResults: function () {
			return (this.results.length > 0);
		},

		showPrevious: function () {
			return this.last > 0;
		},

		showNext: function () {
			return (this.last + this.limit) < this.total;
		},

	},

	created() {
		UWEvent.listen('tagRemoved', this.updateSearch);
		UWEvent.listen('tagSelected', this.updateSearchFields);
		UWEvent.listen('resultSelected', this.showResultDetail);

	},

	methods: {

		getPrevious() {
			this.last = this.last > this.limit ? this.last - this.limit : 0;
			this.getResults();
		},

		getNext() {
			this.last += this.limit;
			this.getResults();
		},

		resetSearchInputs() {
			this.searchString = '';
			this.searchType = 'all';
			this.last = 0;
		},

		addSearchItem() {
			var tag = new Tag(this.searchType, this.searchString);
			this.removeSearchItem(tag, true);
			this.tags.push(tag);
			this.resetSearchInputs();
		},


		removeSearchItem(tag, ignoreContent = false) {
			var targetIndex = -1;
			for (var i = this.tags.length - 1; i >= 0; i--) {
				if (this.tags[i].type == tag.type) {
					if (ignoreContent || this.tags[i].content == tag.content) {
						targetIndex = i;
						break;
					}
				}
			}
			if (targetIndex >= 0) {
				this.tags.splice(targetIndex, 1);
			}
		},

		showResultDetail(result) {
			this.showModal = true;
			this.musicDetail = result;
		},

		updateSearch(tag) {
			this.removeSearchItem(tag);
			this.getResults();
		},

		updateSearchFields(tag) {
			this.searchType = tag.type;
			this.searchString = tag.content;
			this.removeSearchItem(tag);
		},

		getSearchData() {
			var data = {
				_token: $('meta[name="csrf-token"]').attr('content'),
				active_org: activeOrg
			};
			for (var i = 0; i < this.tags.length; i++) {
				var type = this.tags[i].type;
				var content = this.tags[i].content;
				data[type] = content;
			}
			data['last'] = this.last;
			data['limit'] = this.limit;
			return data;
		},

		getResults() {
			console.log("Searching " + this.searchType + " for " + this.searchString + " with org id '" + $('meta[name="active-org"]').attr('content') + "' in the database ");
			var data = this.getSearchData();
			console.log(data);
			this.searching = true;
			axios.post('/search', data)
				.then(function (response) {
					var alertMessage = response.data.status + " - " + response.data.message;
					console.log(alertMessage);
					if (response.data.status === 'success') {
						musicSearcher.firstLoad = false;
						if (response.data.results.length > 0) {
							musicSearcher.results = response.data.results;
							musicSearcher.total = response.data.total;
						} else {
							musicSearcher.results = [];
							musicSearcher.total = 0;
						}
					}
					musicSearcher.searching = false;
				})
				.catch(function (error) {
					console.log(error);
					if (error.response) {
						if (error.response.status == 403) {
							//TODO: Integrate this into the UI
							alert("There seems to be a permissions problem here.\nAre you logged in?");
						}
					}
				});
		},
	}
});